import { LANGUAGE_EN, LANGUAGE_EN_TR, QUERY_AND_SESSION_KEYS, ROUTES, SESSION_STORAGE_KEY_LANGUAGE } from "./constants";
import _ from "lodash";

export function formatCurrency({ amount, currency, locales }) {
    // A missing or non-numeric amount would otherwise be coerced to NaN and rendered as "$NaN".
    const numericAmount = typeof amount === "string" && amount.trim() !== "" ? Number(amount) : amount;
    if (!Number.isFinite(numericAmount)) {
        return null;
    }
    if (!currency) {
        // Intl throws on a currency style without a currency code, so fall back to a plain localised number.
        return new Intl.NumberFormat(locales, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(numericAmount);
    }
    let value = new Intl.NumberFormat(locales, {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(numericAmount);
    if (value.startsWith("-" + currency)) {
        // we want SEK -10 instead of -SEK 10
        value = value.replace("-", "").replace(" ", " −");
    }
    return value;
}

export function routeToHref(route, options, queryParams) {
    let returnHref = !options
        ? route
        : Object.keys(options).reduce((href, key) => {
              return href.replace("[" + key + "]", options[key]);
          }, route);

    if (queryParams) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParams).forEach((key) => {
            searchParams.append(key, queryParams[key]);
        });
        returnHref += "?" + searchParams.toString();
    }
    return returnHref;
}

export function matchAllPolyFill(pattern, text) {
    if (String.prototype.matchAll) {
        return text.matchAll(pattern);
    }
    var regex = new RegExp(pattern, "g");
    var matches = [];

    var match_result = text.match(regex);

    for (let index in match_result) {
        var item = match_result[index];
        matches[index] = item.match(new RegExp(pattern));
    }
    return matches;
}

export function pdfToPdfSrc(pdf) {
    return `data:application/pdf;base64, "${encodeURI(pdf)}`;
}

export function openPDFTab({ pdf, pdfSrc }) {
    let pdfWindow = window.open("");
    pdfWindow.document.write(
        `<iframe style='position: fixed; top: 0; bottom:0; right: 0; border:none; margin: 0; padding: 0; overflow: hidden; width:100%; height:100%;' src='${pdfSrc || pdfToPdfSrc(pdf)}'></iframe>`,
    );
}

export function getOrderName({ foreignId, foreignNumber, foreignName } = {}) {
    return foreignName || foreignNumber || foreignId;
}

export function getOrderStatusUrl({ brandName, foreignOrderId, email, returnId, language }) {
    return (
        ROUTES.STATUS.pathname.replace("[brand]", brandName).replace("[order]", foreignOrderId) +
        "?email=" +
        encodeURIComponent(email) +
        (returnId ? "&" + QUERY_AND_SESSION_KEYS.SELECTED_RETURN + "=" + returnId : "") +
        (language ? "&" + SESSION_STORAGE_KEY_LANGUAGE + "=" + language : "")
    );
}

export function getAllMissingTranslations(obj, { startingKey = "", language, delimiter = "." } = {}) {
    var keys = [];
    for (var key in obj) {
        if (obj[key][LANGUAGE_EN] && !obj[key][language]) {
            keys.push({
                key: startingKey + key,
                text: obj[key][LANGUAGE_EN_TR] || obj[key][LANGUAGE_EN],
            });
        }
        // keys.push({key, value: obj[key][LANGUAGE_EN]});

        if (typeof obj[key] === "object" && !obj[key][LANGUAGE_EN]) {
            // We know that this is not an language end leaf
            var subkeys = getAllMissingTranslations(obj[key], {
                startingKey: startingKey + key + delimiter,
                language,
                delimiter,
            });
            keys = keys.concat(subkeys);
        }
    }
    return keys;
}

export function isValueEmpty(v) {
    return v === "" || v === null || v === undefined || v === false;
}

export function isInputValueChanged(originalValue, value) {
    if (_.isArray(value)) {
        return originalValue?.length !== value?.length || value?.find((v) => !originalValue?.includes(v));
    }
    return !(isValueEmpty(value) && isValueEmpty(originalValue)) && originalValue !== value;
}

export function stripHTMLTags(str) {
    if (str === null || str === "") {
        return false;
    }
    return str.toString().replace(/<[^>]*>/g, "");
}
